module.exports = __webpack_public_path__ + "img/ECG_E4_A1.4df891ca.png";